<template>
  <div>
    <div class="gt-modal-wrap"><div class="gt-overlay" style="position: fixed; top: 0px; left: 0px; width: 100%; height: 100%; opacity: 0.35; background: rgb(51, 51, 51); z-index: 1050;"></div>
      <div id="estimate_modal" class="gt-modal" style="display: block; padding-top: 5%">
        <div class="gt-modal-content gt-animate-opacity" style="width: 1000px">
          <div class="gt-modal-body p-0" style="max-height: 800px">
            <div class="modal-wrapper" id="estimate">
              <div class="modal-container">
                <div class="modal-body" style="border: 2px solid #ddd; padding: 0px 20px 10px;">
                  <table id="print-area" name="main_table" border="0" cellpadding="0" cellspacing="0" class="estimate_data">
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF"><br> <br>
                          
                          <CompanyInfo 
                              :print-mode="printMode"
                              @change-print-mode="changePrintMode"
                          />
                          
                          <EstimateDetail/>
                          
                          <div class="pt-15"><b>ㆍ</b>도메인 견적은 등록 가능한 견적일 당일에 준하며, 견적 시점 이후에는 연장이  불가능하거나, 비용이 달라질 수 있습니다.  </div>
                          
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!--  -->
        
            <div class="modal-footer text-center pv-20">
              <button type="button" class="hw-pill-button smaller" @click="print">인 쇄</button>
              <button type="button" class="hw-pill-button ghost smaller ml-10" @click="hideEstimate">닫기</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyInfo from "@/components/step1/Estimate/CompanyInfo"
import EstimateDetail from "@/components/step1/Estimate/EstimateDetail";

export default {
  name: "Estimate",
  components: {
    CompanyInfo: CompanyInfo,
    EstimateDetail: EstimateDetail,
  },
  data(){
    return {
      printMode: false,
    }
  },
  methods: {
    hideEstimate(){
      this.$emit('hide-estimate')
    },
    print () {
      this.printMode = true
      this.$nextTick(()=>{
        this.$htmlToPaper('estimate');
      })
    },
    changePrintMode(){
      this.printMode = false
    }
  }
}
</script>

<style scoped>

</style>